import React from 'react';
import Header from '../components/Header';
import SearchSection from '../components/SearchSection';
import HeroSection from '../components/HeroSection';
import AnnouncementBanner from '../components/AnnouncementBanner';
import WhyChooseUs from '../components/WhyChooseUs';
import TopDestinations from '../components/TopDestinations';
import HandpickedDestinations from '../components/HandpickedDestinations';
import LastMinuteDeals from '../components/LastMinuteDeals';
import TravelStories from '../components/TravelStories';
import EarlyBirdDeals from '../components/EarlyBirdDeals';
import SimpleFooter from '../components/SimpleFooter';
import ChatFAB from '../components/ChatFAB';
import PromoPopup from '../components/PromoPopup';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      <SearchSection />
      
      <main className="main-content-new">
        <HeroSection />
        <AnnouncementBanner />
        <TopDestinations />
        <HandpickedDestinations />
        <LastMinuteDeals />
        <WhyChooseUs />
        <TravelStories />
        <EarlyBirdDeals />
      </main>

      <SimpleFooter />
      <ChatFAB />
      <PromoPopup />
    </div>
  );
};

export default Home;
